import { NumberField as GammaNumberField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type NumberFieldProps = React.ComponentProps<typeof GammaNumberField>

type Props = Omit<NumberFieldProps, 'selectValue' | 'missingLabel' | 'locale'> & {
  missingLabel?: string
}

const NumberField = ({ missingLabel, ...props }: Props) => (
  <GammaNumberField
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    locale={i18n.locale}
  />
)

export default NumberField
